import { WORDPRESS_API } from "shared/constants/api";

export const maturaDocuments = [
  {
    id: "organizacja",
    title: "Organizacja i przeprowadzanie egzaminu maturalnego w roku szkolnym 2026/2027",
    href: `/assets/doc/matura/20260820_EM_2027_Informacja_fin.pdf`
  },
  {
    id: "deklaracja",
    title: "Deklaracja przystąpienia",
    href: `/assets/doc/matura/EM_2027_Zal_1a_Deklaracja_A_fin.pdf`
  },
  {
    id: "deklaracja-ele",
    title: "Deklaracja przystąpienia w postaci elektronicznej",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/20250820-Ortografia-na-egzaminach.pdf`
  },
  {
    id: "lista-sys",
    title: "Egzamin maturalny z informatyki w 2027 roku",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/20260820_EM_Komunikat_o_egzaminie_z_informatyki_2027_fin.pdf`
  },
  {
    id: "lista-jawnych",
    title: "Lista jawnych zadań z języka polskiego w latach 2026-2028",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/JEZYK-POLSKI_Zadania-jawne-na-2026-r._2027-r.-i-2028-r.-_KOMUNIKAT.pdf`
  },
  {
    id: "lista-jawnych-niew",
    title: "Lista jawnych zadań z języka polskiego w latach 2026-2028 dla niewidomych",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/Jezyk-POLSKI-dla-osob-niewidomych-_Zadania-jawne-na-2026-r._2027-r.-i-2028-r._KOMUNIKAT.pdf`
  },
  {
    id: "materialy",
    title: "Materiały i przybory pomocnicze",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/20260820_E8_EM_Komunikat_o_przyborach_2027_fin.pdf`
  },
  {
    id: "ocenianie",
    title: "Ocenianie poprawności ortograficznej",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/20250820-Ortografia-na-egzaminach.pdf`
  },
  {
    id: "dostosowania",
    title: "Dostosowania warunków w roku szkolnym 2026/2027",
    href: `${WORDPRESS_API}/wp-content/uploads/2026/09/20260820_EM_Komunikat_o_dostosowaniach_2027_fin.pdf`
  },
];